<form id="card-form" class="col mx-auto" [formGroup]="cardForm" (ngSubmit)="tokenizer.submit()">
  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="First Name" formControlName="firstName">
  </div>

  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="Last Name" formControlName="lastName">
  </div>

  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="Address Line 1" formControlName="addressLine1">
  </div>

  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="Address Line 2" formControlName="addressLine2">
  </div>

  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="City" formControlName="city">
  </div>

  <div class="row g-0 my-1">
    <div class="col">
      <input type="text" class="form-control rounded-end-0" placeholder="State" formControlName="state" [ngStyle]="{'pointer-events':'none'}" readonly>
    </div>
    <div ngbDropdown class="col d-flex">
      <button type="button" class="btn btn-primary rounded-start-0" id="dropdownBasic1" ngbDropdownToggle>
        Select State
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        @for (state of states; track $index) {
          <button ngbDropdownItem type="button" (click)="selectState(state)">{{ state.name }} | {{ state.code }}</button>
        }
      </div>
    </div>
    
  </div>

  <div class="row g-0 my-1">
    <input type="text" class="form-control" placeholder="Zip Code" formControlName="zip">
  </div>

  <div class="row g-0 my-1">
    <div class="col">
      <input 
        placeholder="yy/mm/dd" 
        class="form-control rounded-end-0" 
        ngbDatepicker #d="ngbDatepicker" 
        [maxDate]="maxDate"
        [minDate]="minDate"
        [ngStyle]="{'pointer-events':'none'}"
        formControlName="dateOfBirth"
        readonly
      >
    </div>
    <div class="col d-flex">
      <button class="btn btn-primary bi bi-calendar3 rounded-start-0" (click)="d.toggle()" type="button">Select Date of Birth</button>
    </div>
  </div>

  <div class="row g-0 my-1">
    <input placeholder="john.doe@email.com" class="form-control" formControlName="email">
  </div>

  <div class="row g-0 my-1">
    <input type="text" formControlName="phoneNumber" placeholder="Phone Number" class="form-control">
  </div>

  <div class="row g-0 my-1">
    <div id="payment-form" class="flex-grow-1"></div>
    <button class="btn btn-primary" id="card-button" type="submit" [disabled]="!cardForm.valid">Pay ${{price / 100}}</button>
  </div>
</form>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>